<template>
<!-- 移动端 扫码下载页面 -->
  <div class="box">
    <div class="logo">
      <img src="../../../assets/console/cpgl/logo.png" alt="">
    </div>
    <div class="download_button">
      <a v-if="value" :href="iosLink" target="_blank" rel="noopener noreferrer">
        <img src="../../../assets/console/cpgl/ios.png" alt="">
        IOS版下载
      </a>
      <a v-if="!value" :href="androidLink" target="_blank" rel="noopener noreferrer">
        <img src="../../../assets/console/cpgl/android.png" alt="">
        Android版下载
      </a>
    </div>
  </div>
</template>

<script>
import { queryAttributeValueByProductId } from '@/api/channel/product.js'
export default {
  data() {
    return {
      data: [],
      value: true,
      iosLink: '',
      androidLink: '',
    }
  },
  created() {
    this.appSource();
  },
  methods: {
    appSource() {
      let index = window.location.href.indexOf("=");
      let str = window.location.href.substring(index+1);
      let id = str - 0;
      queryAttributeValueByProductId(id).then(res => {
        let arr = [];
        res.data.list.forEach(e => {
          if(e.flag == 'download') {
            arr.push(e);
          }
        });
        for(let i = 0; i < arr.length; i++) {
          if(arr[i].name == "iOS") {
            this.iosLink = arr[i].value;
          } else if(arr[i].name == "Android") {
            this.androidLink = arr[i].value;
          }
        }
      })
      //判断手机为安卓还是苹果
      var u = navigator.userAgent;
      if(u.indexOf('Android') > -1 || u.indexOf('Adr') > -1){
        // this.value = "android-douwnurl";
        this.value = false;
      }else{
        // this.value = "ios-douwnurl";
        this.value = true;
      }
    }
  },
}
</script>

<style lang="scss" scoped="scoped">
.box {
  position: absolute;
	top: 0px;
	bottom: 0px;
  width: 100%;
  height: 100%;
  background: url('../../../assets/console/cpgl/background_img.png') no-repeat fixed center center;
  background-size: cover;
  .logo {
    display: flex;
    justify-content: center;
    margin-top: 25%;
    img {
      width: 30%;
    }
  }
  .download_button {
    display: flex;
    justify-content: center;
    width: 100%;
    margin-top: 30%;
    a {
      position: relative;
      width: 50%;
      height: 38px;
      margin-top: 100px;
      background-color: #5984EC;
      font-size: 14px;
      color: #fff;
      text-decoration: none;
      text-align: center;
      line-height: 38px;
      img {
        position: absolute;
        top: 2px;
        left: 10px;
        width: 30px;
        height: 30px;
      }
    }
  }
}
</style>